<div class="order-type-radio-group">
  <div *ngFor="let item of DELIVER_TYPE_OPTIONS"
       class="order-type-radio-group__option"
       (click)="onInputSelected(item.id)"
       [class.checked]="value === item.id">
    <label>{{ item.name | transloco}}</label>
    <input type="radio" name="order-type" [value]="item.id" />
  </div>
</div>